module.exports = __webpack_public_path__ + "static/media/PATS_4-480w.e2ce5d9b.webp";